import {
    DocumentRole,
    isSuperUserSiteRole,
    type MemberAccess,
} from 'types/Roles';

import { getAppBroker } from './AppBroker';
import DocumentStore from './DocumentStore';
import MembersManager from './MembersManager';

export default class DocumentWithMembershipStore<
    Schema extends MemberAccess = any,
    PublicSchema extends object = any,
> extends DocumentStore<Schema, PublicSchema> {
    members: MembersManager = new MembersManager(this); // Reference to the MembersManager for managing the members that belong to this document.

    private hasPermission(action: DocumentRole): boolean {
        const currentUser = getAppBroker().getCurrentUser();
        if (!currentUser) return false;
        if (isSuperUserSiteRole(currentUser.role)) {
            return true;
        }

        // Wouldn't it make more sense for members.can{Modify,View} to check
        // whether itself is enabled?
        if (!this.members.enabled) return false;

        switch (action) {
            case DocumentRole.EDIT:
                return this.members.canEdit(currentUser.id);
            case DocumentRole.VIEW:
                return this.members.canView(currentUser.id);
        }
    }

    /**
     * @returns Returns if the document can be modified by the current user.
     */
    get canEdit(): boolean {
        return this.hasPermission(DocumentRole.EDIT);
    }

    /**
     * @returns Returns if the document can be viewed by the current user.
     */
    get canView() {
        return this.hasPermission(DocumentRole.VIEW);
    }
}
